import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router, RouterLink, RouterModule } from "@angular/router";
import { AuthService } from 'projects/chat-common/src/lib/services/auth.service';
import {environment} from '../../../environments/environment';
import { InstallTutorialDialogComponent } from '../../chat-gpt/components/install-dialog/install-dialog.component';
import { showAppDownload } from '../../app-origin';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: true,
   imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterLink,InstallTutorialDialogComponent,RouterModule ],
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginForm: FormGroup;
  loginError: any;
  isLoading: boolean;
  @Input() drLogin: boolean = false;

  public showTutorial: boolean = false;
  public readonly showAppDownload = showAppDownload();
  public forgotPasswordUrl = environment.resetPassword;

  constructor(private formBuilder: FormBuilder,
    private auth: AuthService,
    private router: Router) {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnInit() {}


  onSubmit() {
    if (this.loginForm.valid) {
      this.isLoading = true;
      let auth$ = this.auth.signIn(this.loginForm.controls['email'].value, this.loginForm.controls['password'].value);
      auth$.subscribe({
        next: (v) => console.log(v),
        error: (e) => {
          let erroMsg = e?.code == 401 ? 'Incorrect e-mail or password. Please try again.' :  'Something went wrong. Please try again.';
          this.loginError = erroMsg;
          this.isLoading = false;
        },
        complete: () => {
           this.isLoading = false;
          this.router.navigate(['health-assistant'])
        }
      })
    }
  }

  isFieldInvalid(password: string) {
    return false;
  }
}
